export default __webpack_public_path__ + "static/green_frog_mobile-fce88952b49d63d0b69a2ecb1f89142a.png";